import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ArrowLeft: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--arrowLeft')}
    data-icon={icon}
    width="6"
    height="11"
    viewBox="0 0 6 11"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Disclosure-Arrow"
        transform="translate(3.500000, 5.500000) rotate(-90.000000) translate(-3.500000, -5.500000) translate(-2.000000, 3.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <polygon
          id="Arrow-Left"
          transform="translate(5.467773, 2.098040) rotate(-180.000000) translate(-5.467773, -2.098040) "
          points="5.46777344 1.24035424 9.84097032 4.91494909 10.8059293 3.76653529 5.46777344 -0.718869868 0.129617616 3.76653529 1.09457655 4.91494909"
        />
      </g>
    </g>
  </svg>
);

export default ArrowLeft;
